<h2 mat-dialog-title>
  {{ data.id ? 'Edit Resource Attribute' : 'Add Resource Attribute' }}
</h2>
<form (ngSubmit)="onSubmit()" #attributeForm="ngForm" autocomplete="off">
  <mat-dialog-content>
    <div *ngIf="data.external" style="background-color: #fff3cd; border: 1px solid #ffc107; border-radius: 4px; padding: 12px; margin-bottom: 16px;">
      <strong>⚠️ External Attribute</strong>
      <p style="margin: 4px 0 0 0; font-size: 14px;">This attribute is managed externally via SSO and cannot be edited.</p>
    </div>

    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Name</mat-label>
      <input matInput name="name" [(ngModel)]="data.name" [disabled]="!!data.external" required />
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      style="width: 100%;"
    >
      <mat-label>Type</mat-label>
      <mat-select name="type" [(ngModel)]="data.type" [disabled]="!!data.external" required (selectionChange)="onTypeChange()">
        <mat-option value="text">Text</mat-option>
        <mat-option value="number">Number</mat-option>
        <mat-option value="checkbox">Checkbox</mat-option>
        <mat-option value="select">Select</mat-option>
      </mat-select>
      <mat-hint
        >Determines how this attribute will be displayed and
        edited</mat-hint
      >
    </mat-form-field>


    <ng-container *ngIf="data.type === 'select'">
      <mat-form-field appearance="outline" style="width: 100%; margin-top: 1rem;">
        <mat-label>Display Values</mat-label>
        <input matInput name="selectDisplayValues" [(ngModel)]="selectDisplayValues" [disabled]="!!data.external" placeholder="e.g. Red, Green, Blue" />
        <mat-hint>Comma separated list of display values (e.g. Red, Green, Blue)</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 100%; margin-top: 1rem;">
        <mat-label>Slug Values</mat-label>
        <input matInput name="selectSlugValues" [(ngModel)]="selectSlugValues" [disabled]="!!data.external" placeholder="e.g. red, green, blue" />
        <mat-hint>Comma separated list of slug values (e.g. red, green, blue)</mat-hint>
      </mat-form-field>
      <div *ngIf="selectError" style="color: #d32f2f; margin-bottom: 1rem;">{{ selectError }}</div>
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close type="button">Cancel</button>
    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="!data.name || !data.type"
    >
      Save
    </button>
  </mat-dialog-actions>
</form>
